import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

import bedroom_cleaning_img from "../../../src/components/images/stage_01/bedroom_cleaning.png";
import bathroom_cleaning_img from "../../../src/components/images/stage_01/bathroom_cleaning.png";
import complete_house_cleaning_img from "../../../src/components/images/stage_01/complete_house_cleaning.png"
import elder_caretaker_img from "../../../src/components/images/stage_01/elder_caretaker_R2.png"
import gardening_img from "../../../src/components/images/stage_01/gardening.png"
import packers_movers_img from "../../../src/components/images/stage_01/complete_packers_movers.png"
import cleaning_labour_img from "../../../src/components/images/stage_01/cleaning_labour.png"
import cooking_preparation_img from "../../../src/components/images/stage_01/cooking preparation.png"
import electrician_labour_img from "../../../src/components/images/stage_01/Electrican_labour.png"
import stove_cleaning_img from "../../../src/components/images/stage_01/stove_cleaning.png"
import slab_cleaning_img from "../../../src/components/images/stage_01/slab_cleaning.png"

// Quick Services Access — each QAS_* file is a fully pre-designed card
// (photo + title + arrow baked into the artwork itself), so these render
// as plain images rather than image+text card components.
import qas_rangoli_art_img      from "../../../src/components/images/stage_01/QAS_IHRA.png";
import qas_fish_tank_img        from "../../../src/components/images/stage_01/QAS_IHFT.png";
import qas_showcase_img         from "../../../src/components/images/stage_01/QAS_IHDC.png";
import qas_chimney_img          from "../../../src/components/images/stage_01/QAS_IHCC.png";
import qas_microwave_oven_img   from "../../../src/components/images/stage_01/QAS_IHMO.png";
import qas_kitchen_cabinet_img  from "../../../src/components/images/stage_01/QAS_IHKC.png";
import qas_window_glass_img     from "../../../src/components/images/stage_01/QAS_IHWG.png";
import qas_wardrobe_img         from "../../../src/components/images/stage_01/QAS_IHWA.png";
import qas_bedroom_arrange_img  from "../../../src/components/images/stage_01/QAS_IHBA.png";
import qas_outside_spaces_img   from "../../../src/components/images/stage_01/QAS_IHBE.png";
import qas_fan_switchboard_img  from "../../../src/components/images/stage_01/QAS_IHCF.png";
import qas_packing_unpacking_img from "../../../src/components/images/stage_01/QAS_IHPU.png";
import qas_furniture_img        from "../../../src/components/images/stage_01/QAS_IHFC.png";
import qas_dusting_wiping_img   from "../../../src/components/images/stage_01/QAS_IHDW.png";
import qas_sweeping_mopping_img from "../../../src/components/images/stage_01/QAS_IHSM.png";
import qas_food_prep_img        from "../../../src/components/images/stage_01/QAS_IHFP.png";
import qas_utensil_img          from "../../../src/components/images/stage_01/QAS_IHCU.png";
import qas_kitchen_cleaning_img from "../../../src/components/images/stage_01/QAS_IHCK.png";
import qas_fridge_img           from "../../../src/components/images/stage_01/QAS_IHRC.png";
import qas_welcome_img          from "../../../src/components/images/stage_01/main_welcome.png";


import {
  Play,
  ShieldCheck,
  Zap,
  Clock3,
  CalendarDays,
  CheckCircle2,
  Star,
  Headphones,
  ChevronRight,
  BadgeCheck,
  Crown,
  Sparkles,
  Home,
  Package,
  Gem,
  Award,
  Percent,
  Gift,
  Bookmark,
  Plus,
} from "lucide-react";

import {
  CORE_PLANS,
  formatInr,
} from "../membership/membershipPlansData";
import { HOME_PAGE_INSTANT_BOOKING_PREVIEW } from "../../config/pricing";


// Quick Services Access — every card links to the Instant Home Services
// catalog page; the QAS_* artwork already carries its own title + CTA, so
// no separate price/rating text is rendered alongside it.
const QUICK_ACCESS_LINK = "/services/instant-home-services";
const topPopularServices = [
	{ title: "Rangoli Art",                   image: qas_rangoli_art_img,       link: QUICK_ACCESS_LINK },
	{ title: "Fish Tank Cleaning",             image: qas_fish_tank_img,         link: QUICK_ACCESS_LINK },
	{ title: "Showcase Cleaning",              image: qas_showcase_img,          link: QUICK_ACCESS_LINK },
	{ title: "Chimney Cleaning",               image: qas_chimney_img,           link: QUICK_ACCESS_LINK },
	{ title: "Microwave & Oven Cleaning",      image: qas_microwave_oven_img,    link: QUICK_ACCESS_LINK },
	{ title: "Kitchen Cabinet Cleaning",       image: qas_kitchen_cabinet_img,   link: QUICK_ACCESS_LINK },
	{ title: "Window and Glass Cleaning",      image: qas_window_glass_img,      link: QUICK_ACCESS_LINK },
	{ title: "Wardrobe Arrangement",           image: qas_wardrobe_img,          link: QUICK_ACCESS_LINK },
	{ title: "Bedroom Arrangement",            image: qas_bedroom_arrange_img,   link: QUICK_ACCESS_LINK },
	{ title: "Outside Spaces Cleaning",        image: qas_outside_spaces_img,    link: QUICK_ACCESS_LINK },
	{ title: "Fan & Ceiling Cleaning",            image: qas_fan_switchboard_img, link: QUICK_ACCESS_LINK },
	{ title: "Packing & Unpacking",            image: qas_packing_unpacking_img, link: QUICK_ACCESS_LINK },
	{ title: "Furniture Cleaning",             image: qas_furniture_img,         link: QUICK_ACCESS_LINK },
	{ title: "Dusting & Wiping",               image: qas_dusting_wiping_img,    link: QUICK_ACCESS_LINK },
	{ title: "Sweeping & Mopping",             image: qas_sweeping_mopping_img,  link: QUICK_ACCESS_LINK },
	{ title: "Food Preparation",               image: qas_food_prep_img,         link: QUICK_ACCESS_LINK },
	{ title: "Utensil Cleaning",               image: qas_utensil_img,           link: QUICK_ACCESS_LINK },
	{ title: "Kitchen Cleaning",               image: qas_kitchen_cleaning_img,  link: QUICK_ACCESS_LINK },
	{ title: "Fridge Cleaning",                image: qas_fridge_img,            link: QUICK_ACCESS_LINK },
];





const trustFeatures = [
  {
	title: "Quick Booking",
	desc: "Book a service in less than 60 seconds",
	icon: Clock3,
	iconBg: "#eef2ff",
	iconColor: "#4f46e5",
  },
  {
	title: "Verified Professionals",
	desc: "All professionals are background verified",
	icon: BadgeCheck,
	iconBg: "#eef2ff",
	iconColor: "#4f46e5",
  },
  {
	title: "On-time Service",
	desc: "Punctual and reliable service at your doorstep",
	icon: Clock3,
	iconBg: "#ecfdf3",
	iconColor: "#22c55e",
  },
  {
	title: "24/7 Support",
	desc: "We're here to help anytime, anywhere",
	icon: Headphones,
	iconBg: "#ecfdf3",
	iconColor: "#22c55e",
  },
];

const categories = [
  {
	title: "Home Services",
	description: "Cleaning, Plumbing, AC Service, Electrician & more",
	bg: "#eef1ff",
	image: complete_house_cleaning_img,
	path: "/services/instant-home-services",
  },
  {
	title: "Technical Services",
	description: "Laptop Repair, CCTV, WiFi, Printer & more",
	bg: "#ecfbf7",
	image: electrician_labour_img,
	path: "/services/technical-services",
  },
  {
	title: "Caretaker Services",
	description: "Elder Care, Baby Care, Patient Care & more",
	bg: "#fff0ef",
	image: elder_caretaker_img,
	path: "/services/caretaker-services",
  },
  {
	title: "Outdoor Services",
	description: "Gardening, Landscaping, Security, Pest Control & more",
	bg: "#f3f9e9",
	image: gardening_img,
	path: "/services/outdoor-services",
  },
  {
	title: "Transport Services",
	description: "Packers & Movers, Courier, Driver, Bike Transport & more",
	bg: "#fff7e8",
	image: packers_movers_img,
	path: "/services/transport-services",
  },
];

const steps = [
  {
	no: "01",
	title: "Choose Service",
	description: "Select the service you need from our categories",
	color: "#1677ff", bg: "#eef6ff",
	icon: (
	  <svg viewBox="0 0 64 64" className="cn-how-icon">
		<circle cx="27" cy="27" r="15" />
		<line x1="38" y1="38" x2="51" y2="51" />
	  </svg>
	),
  },
  {
	no: "02",
	title: "Select Method",
	description: "Select the service method - Instant, Schedule or Recurring",
	color: "#743cff", bg: "#f5efff",
	icon: (
	  <svg viewBox="0 0 64 64" className="cn-how-icon">
		<circle cx="27" cy="20" r="9" />
		<path d="M10 48c0-10 7-17 17-17s17 7 17 17" />
		<circle cx="47" cy="44" r="10" />
		<path d="M47 38v6l4 3" />
	  </svg>
	),
  },
  {
	no: "03",
	title: "Book Time Slot",
	description: "Choose your preferred date and time",
	color: "#ff9700", bg: "#fff5e7",
	icon: (
	  <svg viewBox="0 0 64 64" className="cn-how-icon">
		<rect x="10" y="13" width="39" height="38" rx="5" />
		<line x1="10" y1="24" x2="49" y2="24" />
		<line x1="20" y1="8" x2="20" y2="17" />
		<line x1="39" y1="8" x2="39" y2="17" />
		<circle cx="38" cy="43" r="11" />
		<line x1="38" y1="37" x2="38" y2="43" />
		<line x1="38" y1="43" x2="43" y2="46" />
	  </svg>
	),
  },
  {
	no: "04",
	title: "Get It Done",
	description: "Sit back and relax while we get the job done",
	color: "#12b84b", bg: "#edfff3",
	icon: (
	  <svg viewBox="0 0 64 64" className="cn-how-icon">
		<circle cx="32" cy="32" r="20" />
		<polyline points="22,32 29,39 43,24" />
	  </svg>
	),
  },
];

const professionals = [
  {
	name: "Rahul Kumar",
	role: "Electrician",
	rating: "4.8",
	reviews: "1.2k",
	jobs: "1,200+ Jobs Completed",
	image: electrician_labour_img,
  },
  {
	name: "Anita Sharma",
	role: "Home Cleaner",
	rating: "4.7",
	reviews: "980",
	jobs: "980+ Jobs Completed",
	image: cleaning_labour_img,
  },
  {
	name: "Kavya Nair",
	role: "Cook",
	rating: "4.8",
	reviews: "1.5k",
	jobs: "1,500+ Jobs Completed",
	image: cooking_preparation_img,
  },
  {
	name: "Meera Iyer",
	role: "Kitchen Cleaner",
	rating: "4.7",
	reviews: "870",
	jobs: "870+ Jobs Completed",
	image: stove_cleaning_img,
  },
  {
	name: "Divya Menon",
	role: "Slab & Counter Cleaning",
	rating: "4.8",
	reviews: "1.1k",
	jobs: "1,100+ Jobs Completed",
	image: slab_cleaning_img,
  },
];

const testimonials = [
  {
	text: "Booked a plumber at midnight and he arrived within 30 minutes. Excellent service!",
	name: "Priya S.",
	city: "Bangalore",
  },
  {
	text: "Very professional and polite caretaker. My parents are in safe hands.",
	name: "Arjun K.",
	city: "Delhi",
  },
  {
	text: "Quick booking, transparent pricing and amazing customer support.",
	name: "Neha T.",
	city: "Mumbai",
  },
];

const PLAN_ICONS = { Package, Home, Gem, Award, Crown };

const HomePageContent = () => {

	return (
		<main style={styles.page}>
	  <div style={styles.container}>


		{/* Popular Services from image 2 */}
		<section style={styles.section}>
			<div style={styles.rowHead}>
				<h2 style={styles.sectionTitle}>Quick Services Access</h2>
				<Link to={QUICK_ACCESS_LINK} style={styles.viewAllBtn}>
					Book Now <ArrowRight size={14} />
				</Link>
			</div>

			<div style={styles.quickAccessSplit}>
				<div style={styles.quickAccessGrid}>
					{topPopularServices.map((item) => (
					<Link key={item.title} to={item.link} style={{ textDecoration: "none" }}>
						<div
							style={{ ...styles.quickAccessCard, cursor: "pointer", transition: "transform 0.18s, box-shadow 0.18s" }}
							onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = "0 8px 24px rgba(0,0,0,0.12)"; }}
							onMouseLeave={e => { e.currentTarget.style.transform = ""; e.currentTarget.style.boxShadow = ""; }}
						>
							<img
								src={item.image}
								alt={item.title}
								style={styles.quickAccessGridImg}
							/>
							<div style={styles.quickAccessCaption}>
								<span>{item.title}</span>
								<ArrowRight size={13} />
							</div>
						</div>
					</Link>
					))}
				</div>

				<Link to={QUICK_ACCESS_LINK} style={styles.quickAccessWelcomeWrap}>
					<img
						src={qas_welcome_img}
						alt="Welcome to ClickNido"
						style={styles.quickAccessWelcomeImg}
					/>
				</Link>
			</div>
		</section>

		{/* Booking Options — Instant / Schedule / Subscription */}
		<section style={styles.section}>
			<div style={styles.bookingOptionsGrid}>

				<div style={{ ...styles.bookingCard, background: "#f5f3ff" }}>
					<span style={{ ...styles.bookingBadge, background: "#ece9ff", color: "#4f46e5" }}>
						<Zap size={12} /> INSTANT BOOKING
					</span>
					<h3 style={styles.bookingTitle}>
						Instant Service,<br /><span style={{ color: "#4f46e5" }}>Right Away</span>
					</h3>
					<p style={styles.bookingDesc}>Choose a service and get it done instantly.</p>

					<div style={styles.bookingMiniGrid}>
						{[
							{ name: "Kitchen Cleaning", price: HOME_PAGE_INSTANT_BOOKING_PREVIEW["Kitchen Cleaning"] },
							{ name: "Bathroom Cleaning", price: HOME_PAGE_INSTANT_BOOKING_PREVIEW["Bathroom Cleaning"] },
							{ name: "Sofa Cleaning", price: HOME_PAGE_INSTANT_BOOKING_PREVIEW["Sofa Cleaning"] },
							{ name: "AC Cleaning", price: HOME_PAGE_INSTANT_BOOKING_PREVIEW["AC Cleaning"] },
						].map((s) => (
							<div key={s.name} style={styles.bookingMiniTile}>
								<div style={styles.bookingMiniName}>{s.name}</div>
								<div style={styles.bookingMiniPrice}>₹{s.price}</div>
							</div>
						))}
					</div>

					<Link to="/services/instant-home-services" style={styles.bookingViewAll}>
						View all services <ArrowRight size={14} />
					</Link>

					<Link to="/services/instant-home-services" style={{ ...styles.bookingCta, background: "#4f46e5" }}>
						Book Now
					</Link>
				</div>

				<div style={{ ...styles.bookingCard, background: "#effaf3" }}>
					<span style={{ ...styles.bookingBadge, background: "#dcfce7", color: "#16a34a" }}>
						<CalendarDays size={12} /> SCHEDULE BOOKING
					</span>
					<h3 style={styles.bookingTitle}>
						Plan Your Service,<br /><span style={{ color: "#16a34a" }}>We'll Take Care</span>
					</h3>
					<p style={styles.bookingDesc}>Pick a convenient time. 15+ services available in 1 or 2 hours.</p>

					<div style={styles.bookingDurationRow}>
						<div style={styles.bookingDurationTile}>
							<Clock3 size={18} color="#16a34a" />
							<div style={styles.bookingDurationTitle}>1 Hour Service</div>
							<div style={styles.bookingDurationSub}>Quick &amp; Efficient</div>
							<div style={styles.bookingDurationCount}>18 Services</div>
						</div>
						<div style={styles.bookingDurationTile}>
							<Clock3 size={18} color="#16a34a" />
							<div style={styles.bookingDurationTitle}>2 Hour Service</div>
							<div style={styles.bookingDurationSub}>Deep &amp; Complete</div>
							<div style={styles.bookingDurationCount}>18 Services</div>
						</div>
					</div>

					<Link to="/schedule-booking" style={{ ...styles.bookingCta, background: "#16a34a", marginTop: "18px" }}>
						Schedule Now
					</Link>
				</div>

				<div style={{ ...styles.bookingCard, background: "#fff8e9" }}>
					<span style={{ ...styles.bookingBadge, background: "#fef3c7", color: "#d97706" }}>
						<Crown size={12} /> SUBSCRIPTION PLANS
					</span>
					<h3 style={styles.bookingTitle}>
						Save More with<br /><span style={{ color: "#d97706" }}>Subscription</span>
					</h3>
					<p style={styles.bookingDesc}>Weekly, Monthly &amp; Premium plans with amazing benefits.</p>

					<ul style={styles.bookingFeatureList}>
						{["Priority Booking", "Exclusive Discounts", "Free Rescheduling", "Dedicated Support"].map((f) => (
							<li key={f} style={styles.bookingFeatureItem}>
								<CheckCircle2 size={14} color="#d97706" /> {f}
							</li>
						))}
					</ul>

					<Link to="/subscription-plans" style={{ ...styles.bookingCta, background: "#d97706", marginTop: "14px" }}>
						View Plans
					</Link>
				</div>

			</div>
		</section>


		{/* Top Hero from image 2 */}
		<section style={styles.heroSection}>
		  <div style={styles.heroGrid}>
			<div style={styles.heroLeft}>
			  <div style={styles.offerBadge}>🎁 10% OFF on First Booking</div>

			  <h1 style={styles.heroTitle}>
				A Cleaner, <span style={styles.heroAccent}>Happier Home</span>
				<br />
				Starts Here
			  </h1>

			  <p style={styles.heroText}>
				Professional. Reliable. Hassle-Free.
			  </p>

			  <div style={styles.heroTrustRow}>
					{[
					  { icon: BadgeCheck,   label: "Verified Professionals" },
					  { icon: ShieldCheck,  label: "Transparent Pricing" },
					  { icon: Clock3,       label: "On-time Service" },
					  { icon: CheckCircle2, label: "Satisfaction Guaranteed" },
					].map((item) => {
					  const Icon = item.icon;
					  return (
						<div key={item.label} style={styles.heroTrustItem}>
						  <Icon size={16} color="#3FC9A3" />
						  <span>{item.label}</span>
						</div>
					  );
					})}
			  </div>
			</div>

			<div style={styles.heroCenter}>
			  <div style={styles.heroImageCard}>
				<img
				  src={cleaning_labour_img}
				  alt="ClickNido professional cleaner"
				  style={styles.heroImage}
				/>
				<button style={styles.playBtn}><Play size={24} fill="#fff" color="#fff" />
				</button>

				<div style={styles.trustedBadge}>
				  <div style={styles.heroRating}>
					4.8 <Star size={18} fill="#f4b400" color="#f4b400" />
				  </div>
				  <div>
					<div style={styles.trustedTitle}>Trusted Professionals</div>
					<div style={styles.trustedSub}>Background verified</div>
				  </div>
				</div>
			  </div>
			</div>

			<div style={styles.heroRight}>
			  <div style={{ ...styles.sideInfoCard, background: "#f5f3ff" }}>
				<div style={{ ...styles.sideIconWrap, background: "#ece9ff" }}>
				  <Clock3 size={18} color="#635bff" />
				</div>
				<div style={styles.sideCardBody}>
				  <h4 style={styles.sideCardTitle}>Instant Booking</h4>
				  <p style={styles.sideCardText}>Book in 60 seconds</p>
				</div>
				<ArrowRight size={18} color="#635bff" />
			  </div>

			  <div style={{ ...styles.sideInfoCard, background: "#effaf3" }}>
				<div style={{ ...styles.sideIconWrap, background: "#dcfce7" }}>
				  <ShieldCheck size={18} color="#22c55e" />
				</div>
				<div style={styles.sideCardBody}>
				  <h4 style={styles.sideCardTitle}>Schedule Service</h4>
				  <p style={styles.sideCardText}>Book at you Suitable Slot</p>
				</div>
				<ArrowRight size={18} color="#22c55e" />
			  </div>

			  <div style={{ ...styles.sideInfoCard, background: "#fff8e9" }}>
				<div style={{ ...styles.sideIconWrap, background: "#fef3c7" }}>
				  <Zap size={18} color="#f59e0b" />
				</div>
				<div style={styles.sideCardBody}>
				  <h4 style={styles.sideCardTitle}>Recurring</h4>
				  <p style={styles.sideCardText}>Submit the Requirement</p>
				</div>
				<ArrowRight size={18} color="#f59e0b" />
			  </div>
			</div>
		  </div>
		</section>


		{/* Feature strip from image 2 */}
		<section style={styles.section}>
		  <div style={styles.trustStrip}>
			{trustFeatures.map((feature) => {
			  const Icon = feature.icon;
			  return (
				<div key={feature.title} style={styles.trustItem}>
				  <div
					style={{
					  ...styles.trustIconBox,
					  background: feature.iconBg,
					}}
				  >
					<Icon size={18} color={feature.iconColor} />
				  </div>
				  <div>
					<h4 style={styles.trustTitle}>{feature.title}</h4>
					<p style={styles.trustDesc}>{feature.desc}</p>
				  </div>
				</div>
			  );
			})}
		  </div>
		</section>

		{/* Membership / Subscription Plans */}
		<section style={styles.section}>
			<style>{`
				@media (max-width: 1100px) {
					.cn-membership-wrap {
						grid-template-columns: 1fr !important;
					}
					.cn-membership-grid {
						grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
					}
				}
				@media (max-width: 640px) {
					.cn-membership-grid {
						display: flex !important;
						overflow-x: auto !important;
						align-items: stretch !important;
						scroll-snap-type: x mandatory;
						-webkit-overflow-scrolling: touch;
						scrollbar-width: none;
						padding-bottom: 6px;
					}
					.cn-membership-grid::-webkit-scrollbar { display: none; }
					.cn-membership-card, .cn-membership-view-all {
						flex: 0 0 78%;
						scroll-snap-align: center;
					}
				}
			`}</style>

			<div className="cn-membership-wrap" style={styles.membershipWrap}>

				{/* Left intro column */}
				<div style={styles.membershipIntro}>
					<Link to="/subscription-plans" style={styles.membershipEyebrowLink}>
						<Bookmark size={13} /> Save More with ClickNido Membership
					</Link>
					<h2 style={styles.membershipTitle}>
						Choose a Plan<br />
						<span style={styles.membershipTitleAccent}>That Suits You</span>
					</h2>
					<p style={styles.membershipIntroText}>
						Get exclusive discounts, priority booking, and hassle-free home services.
					</p>
					<div style={styles.membershipFeatureRow}>
						<div style={styles.membershipFeatureItem}>
							<div style={styles.membershipFeatureIcon}><Percent size={18} color="#4f46e5" /></div>
							<span>Save More</span>
						</div>
						<div style={styles.membershipFeatureItem}>
							<div style={styles.membershipFeatureIcon}><Zap size={18} color="#4f46e5" /></div>
							<span>Priority Booking</span>
						</div>
						<div style={styles.membershipFeatureItem}>
							<div style={styles.membershipFeatureIcon}><Gift size={18} color="#4f46e5" /></div>
							<span>Exclusive Offers</span>
						</div>
					</div>
				</div>

				{/* Right: plan cards (each plan has a fixed price — no billing cycle to pick) */}
				<div style={styles.membershipRight}>
					<div className="cn-membership-grid" style={styles.membershipGrid}>
						{CORE_PLANS.map((plan) => {
							const Icon = PLAN_ICONS[plan.icon] || Package;
							const price = plan.price;
							const period = plan.period;
							return (
								<div
									key={plan.id}
									className="cn-membership-card"
									style={{
										...styles.membershipCard,
										...(plan.highlight ? styles.membershipCardPopular : {}),
									}}
								>
									{plan.highlight && (
										<div style={styles.popularRibbon}>
											<Sparkles size={12} /> Most Popular
										</div>
									)}

									<div style={styles.planHeadRow}>
										<div style={{ ...styles.planIconWrap, ...(plan.highlight ? styles.planIconWrapPopular : {}) }}>
											<Icon size={20} color={plan.highlight ? "#fff" : "#4f46e5"} />
										</div>
										<div>
											<h3 style={styles.planName}>{plan.name}</h3>
											<p style={styles.planTagline}>{plan.tagline}</p>
										</div>
									</div>

									<div style={styles.planPriceRow}>
										<span style={styles.planPrice}>{formatInr(price)}</span>
										<span style={styles.planPeriod}>{period}</span>
									</div>

									<div style={styles.planDivider} />

									<ul style={styles.featureList}>
										{plan.features.map((f) => (
											<li key={f} style={styles.featureItem}>
												<CheckCircle2 size={15} color="#4f46e5" />
												<span style={styles.featureText}>{f}</span>
											</li>
										))}
									</ul>

									<Link
										to={`/subscription-plans/checkout/${plan.id}`}
										style={{ ...styles.planCta, ...(plan.highlight ? styles.planCtaPopular : {}), textAlign: "center", textDecoration: "none", display: "block", boxSizing: "border-box" }}
									>
										{plan.cta}
									</Link>
								</div>
							);
						})}

						{/* 4th column — view all plans */}
						<Link to="/subscription-plans" className="cn-membership-view-all" style={styles.viewAllCard}>
							<div style={styles.viewAllIconWrap}>
								<Plus size={22} color="#4f46e5" />
							</div>
							<div style={styles.viewAllTitle}>More Plans</div>
							<p style={styles.viewAllText}>Explore Bronze, Gold, Platinum &amp; more</p>
							<span style={styles.viewAllLink}>
								View All Plans <ArrowRight size={14} />
							</span>
						</Link>
					</div>
				</div>
			</div>
		</section>

		{/* Service Categories from image 1 */}
		<section style={styles.section}>
		  <div style={styles.categoryGridWrap}>
			<div style={styles.leftIntro}>
			  <div style={styles.badge}>📘 Book Everything You Need</div>
			  <h2 style={styles.sectionTitleLarge}>Popular Service Categories</h2>
			  <p style={styles.sectionSubtext}>
				Explore our wide range of professional services tailored for your
				home and beyond.
			  </p>
			</div>

			<div style={styles.categoryGrid}>
			  {categories.map((item) => (
				<Link
				  key={item.title}
				  to={item.path}
				  style={{ ...styles.categoryCard, background: item.bg, textDecoration: "none", color: "inherit" }}
				>
				  <img src={item.image} alt={item.title} style={styles.categoryImage} />
				  <div style={styles.categoryCardBody}>
					<h3 style={styles.cardTitle}>{item.title}</h3>
					<p style={styles.cardDesc}>{item.description}</p>
					<span style={styles.linkBtn}>
					  Explore Services <ArrowRight size={14} />
					</span>
				  </div>
				</Link>
			  ))}
			</div>
		  </div>
		</section>

		{/* How it works — className/scoped-<style> component instead of the
			inline `styles.*` objects everything else here uses, because the
			design needs real CSS (:hover, absolute-positioned connectors,
			media queries) that inline style objects can't express. Every
			class is prefixed cn-how- so it can't collide with the same-named
			.progress-bar (Bootstrap, imported globally in App.js) or
			.section-title (defined in three different global stylesheets)
			that the reference design's own un-prefixed class names would
			have hit. */}
		<style>{`
		  .cn-how-section {
			position: relative;
			width: 100%;
			padding: 40px 32px 46px;
			overflow: hidden;
			background:
			  radial-gradient(circle at 5% 10%, #eef6ff 0, #eef6ff 90px, transparent 220px),
			  radial-gradient(circle at 95% 20%, #f0fff8 0, #f0fff8 90px, transparent 220px),
			  #ffffff;
		  }
		  .cn-how-bg-shape { position: absolute; border-radius: 50%; pointer-events: none; filter: blur(1px); opacity: 0.55; }
		  .cn-how-bg-one { width: 200px; height: 200px; left: -120px; top: 60px; background: #edf5ff; }
		  .cn-how-bg-two { width: 170px; height: 170px; right: -80px; bottom: 10px; background: #effff7; }
		  .cn-how-content { position: relative; z-index: 2; max-width: 1500px; margin: 0 auto; }
		  .cn-how-header { text-align: center; margin-bottom: 28px; }
		  .cn-how-label {
			display: inline-flex; align-items: center; justify-content: center;
			padding: 5px 14px; border-radius: 999px;
			background: linear-gradient(135deg, #f0edff, #f7f5ff);
			color: #5942df; font-size: 11px; font-weight: 800; letter-spacing: 3px;
			text-transform: uppercase; margin-bottom: 10px;
		  }
		  .cn-how-title { margin: 0; font-size: clamp(22px, 2.6vw, 32px); line-height: 1.1; font-weight: 800; color: #07164d; letter-spacing: -1px; }
		  .cn-how-title span { color: #6547f5; }
		  .cn-how-subtitle { margin: 8px 0 0; color: #60728f; font-size: 14px; line-height: 1.5; }
		  .cn-how-steps { position: relative; display: grid; grid-template-columns: repeat(4, 1fr); gap: 22px; align-items: stretch; }
		  .cn-how-card {
			position: relative; min-height: 230px; padding: 18px 16px 18px;
			border: 1px solid rgba(100, 90, 230, 0.12); border-radius: 18px;
			background: rgba(255, 255, 255, 0.88);
			box-shadow: 0 8px 24px rgba(30, 44, 90, 0.06), 0 2px 8px rgba(30, 44, 90, 0.04);
			backdrop-filter: blur(10px);
			display: flex; flex-direction: column; align-items: center; text-align: center;
			transition: transform 0.3s ease, box-shadow 0.3s ease;
		  }
		  .cn-how-card:hover { transform: translateY(-5px); box-shadow: 0 14px 32px rgba(30, 44, 90, 0.11), 0 4px 10px rgba(30, 44, 90, 0.05); }
		  .cn-how-number {
			position: absolute; left: 12px; top: 12px; width: 34px; height: 34px; border-radius: 50%;
			display: flex; align-items: center; justify-content: center;
			color: white; font-size: 13px; font-weight: 800; box-shadow: 0 5px 12px rgba(0,0,0,0.12);
		  }
		  .cn-how-icon-wrap {
			width: 68px; height: 68px; margin: 8px auto 12px; border-radius: 50%;
			display: flex; align-items: center; justify-content: center; position: relative;
		  }
		  .cn-how-icon-wrap::before {
			content: ""; position: absolute; inset: 6px; border-radius: 50%;
			border: 1px solid rgba(100,100,255,0.08);
		  }
		  .cn-how-icon { width: 34px; height: 34px; fill: none; stroke: currentColor; stroke-width: 3.5; stroke-linecap: round; stroke-linejoin: round; position: relative; z-index: 2; }
		  .cn-how-step-title { margin: 0 0 7px; color: #07164d; font-size: 16px; line-height: 1.25; font-weight: 800; }
		  .cn-how-step-desc { margin: 0; max-width: 220px; color: #637590; font-size: 13px; line-height: 1.5; }
		  .cn-how-progress-wrap { width: 100%; height: 5px; margin-top: auto; padding-top: 16px; }
		  .cn-how-progress-track { width: 100%; height: 5px; background: #edf0f7; border-radius: 999px; overflow: hidden; }
		  .cn-how-progress-bar { height: 100%; width: 65%; border-radius: inherit; }

		  .cn-how-connector {
			/* Vertically centered on the icon circle (card padding-top 18px +
			   icon-wrap's own 8px top margin + half its 68px height = 60px
			   from the card's top edge) — top:50% of the whole row used to
			   land near the title/description instead, since taller
			   descriptions stretch the row past the icon's actual position. */
			position: absolute; top: 60px; transform: translateY(-50%);
			width: 44px; height: 44px; z-index: 5;
			display: flex; align-items: center; justify-content: center;
		  }
		  .cn-how-connector-line { position: absolute; left: 0; right: 0; height: 2px; border-top: 2px dotted #b9b5ff; }
		  /* Solid-filled + white icon, not just an outlined circle — reads as
			 an actual connector/CTA instead of a faint decoration. A subtle
			 pulse draws the eye along the sequence without being distracting. */
		  .cn-how-connector-arrow {
			box-sizing: border-box;
			position: relative; width: 44px; height: 44px; border-radius: 50%;
			color: #fff; border: 3px solid #fff;
			display: flex; align-items: center; justify-content: center;
			font-weight: 700; line-height: 0;
			--glow: 70, 60, 180;
			box-shadow: 0 6px 16px rgba(var(--glow), 0.3);
			animation: cn-how-pulse 2.2s ease-in-out infinite;
		  }
		  .cn-how-connector-arrow svg { display: block; }
		  @keyframes cn-how-pulse {
			0%, 100% { box-shadow: 0 6px 16px rgba(var(--glow), 0.3), 0 0 0 0 rgba(var(--glow), 0.35); }
			50%      { box-shadow: 0 6px 16px rgba(var(--glow), 0.3), 0 0 0 6px rgba(var(--glow), 0); }
		  }
		  .cn-how-connector-1 { left: calc(25% - 22px); }
		  .cn-how-connector-2 { left: calc(50% - 22px); }
		  .cn-how-connector-3 { left: calc(75% - 22px); }
		  .cn-how-connector-1 .cn-how-connector-line { border-color: #8db9ff; }
		  .cn-how-connector-1 .cn-how-connector-arrow { background: #1677ff; --glow: 22, 119, 255; }
		  .cn-how-connector-2 .cn-how-connector-line { border-color: #a98cff; }
		  .cn-how-connector-2 .cn-how-connector-arrow { background: #743cff; --glow: 116, 60, 255; }
		  .cn-how-connector-3 .cn-how-connector-line { border-color: #83dca8; }
		  .cn-how-connector-3 .cn-how-connector-arrow { background: #12b84b; --glow: 18, 184, 75; }

		  @media (max-width: 1100px) {
			.cn-how-section { padding: 32px 20px; }
			.cn-how-steps { grid-template-columns: repeat(2, 1fr); gap: 16px; }
			.cn-how-connector { display: none; }
			.cn-how-card { min-height: 210px; }
		  }
		  @media (max-width: 650px) {
			.cn-how-section { padding: 26px 14px; }
			.cn-how-header { margin-bottom: 18px; }
			.cn-how-label { font-size: 9px; letter-spacing: 1.5px; padding: 5px 12px; }
			.cn-how-title { font-size: 24px; letter-spacing: -0.5px; }
			.cn-how-subtitle { font-size: 13px; }
			.cn-how-steps { grid-template-columns: 1fr; gap: 14px; }
			.cn-how-card { min-height: auto; padding: 16px 14px; border-radius: 16px; }
			.cn-how-number { width: 30px; height: 30px; left: 10px; top: 10px; font-size: 12px; }
			.cn-how-icon-wrap { width: 58px; height: 58px; margin-bottom: 10px; }
			.cn-how-icon { width: 28px; height: 28px; }
			.cn-how-step-title { font-size: 15px; }
			.cn-how-step-desc { font-size: 13px; }
		  }
		`}</style>
		<section className="cn-how-section">
		  <div className="cn-how-bg-shape cn-how-bg-one"></div>
		  <div className="cn-how-bg-shape cn-how-bg-two"></div>

		  <div className="cn-how-content">
			<div className="cn-how-header">
			  <div className="cn-how-label">SIMPLE PROCESS</div>
			  <h2 className="cn-how-title">How It <span>Works</span></h2>
			  <p className="cn-how-subtitle">Get your job done in 4 simple steps</p>
			</div>

			<div className="cn-how-steps">
			  {steps.map((step, index) => (
				<React.Fragment key={step.no}>
				  <div className="cn-how-card">
					<div className="cn-how-number" style={{ background: step.color }}>{step.no}</div>
					<div className="cn-how-icon-wrap" style={{ background: step.bg, color: step.color }}>
					  {step.icon}
					</div>
					<h3 className="cn-how-step-title">{step.title}</h3>
					<p className="cn-how-step-desc">{step.description}</p>
					<div className="cn-how-progress-wrap">
					  <div className="cn-how-progress-track">
						<div className="cn-how-progress-bar" style={{ background: step.color }} />
					  </div>
					</div>
				  </div>

				  {index < steps.length - 1 && (
					<div className={`cn-how-connector cn-how-connector-${index + 1}`}>
					  <div className="cn-how-connector-line"></div>
					  <div className="cn-how-connector-arrow"><ArrowRight size={20} strokeWidth={2.5} /></div>
					</div>
				  )}
				</React.Fragment>
			  ))}
			</div>
		  </div>
		</section>

		{/* Featured pros */}
		<section style={styles.section}>
		  <div style={styles.rowHead}>
			<div>
			  <h2 style={styles.sectionTitle}>Featured Professionals</h2>
			</div>
		  </div>

		  <div style={styles.proGrid}>
			{professionals.map((pro) => (
			  <div key={pro.name} style={styles.proCard}>
				<div style={styles.imageWrap}>
				  <img src={pro.image} alt={pro.name} style={styles.proImage} />
				  <span style={styles.availableTag}>Available</span>
				</div>
				<div style={styles.proBody}>
				  <h3 style={styles.proName}>{pro.name}</h3>
				  <p style={styles.proRole}>{pro.role}</p>
				  <div style={styles.ratingRow}>
					<Star size={14} fill="#f4b400" color="#f4b400" />
					<span style={styles.ratingText}>
					  {pro.rating} ({pro.reviews})
					</span>
				  </div>
				  <p style={styles.jobsText}>{pro.jobs}</p>
				</div>
			  </div>
			))}
		  </div>
		</section>

		{/* Testimonials */}
		<section style={styles.section}>
		  <div style={styles.rowHead}>
			<div>
			  <h2 style={styles.sectionTitle}>What Our Customers Say</h2>
			  <p style={styles.sectionSubtextSmall}>
				Real stories from real customers
			  </p>
			</div>
			<button style={styles.viewAllBtn}>
			  View All Reviews <ArrowRight size={14} />
			</button>
		  </div>

		  <div style={styles.testimonialGrid}>
			{testimonials.map((item) => (
			  <div key={item.name} style={styles.testimonialCard}>
				<div style={styles.quoteMark}>❝</div>
				<div style={styles.stars}>
				  {Array.from({ length: 5 }).map((_, i) => (
					<Star
					  key={i}
					  size={14}
					  fill="#f4b400"
					  color="#f4b400"
					/>
				  ))}
				</div>
				<p style={styles.testimonialText}>{item.text}</p>

				<div style={styles.userRow}>
				  				  <div>
					<div style={styles.userName}>{item.name}</div>
					<div style={styles.userCity}>{item.city}</div>
				  </div>
				</div>
			  </div>
			))}
		  </div>
		</section>

		{/* App banner */}
		<section style={styles.section}>
		  <div style={styles.appBanner}>
			<div style={styles.mobileMockWrap}>
			  <div style={styles.mobileMock}>
				<div style={styles.mobileNotch} />
				<div style={styles.mobileScreen}>
				  <p style={styles.mockHello}>Hello, Priya 👋</p>
				  <h4 style={styles.mockTitle}>What service do you need today?</h4>
				  <div style={styles.searchBoxMini}>🔍 Search for a service...</div>
				  <div style={styles.mockSmallTitle}>Popular Services</div>
				  <div style={styles.mockServiceRow}>
					<span style={styles.mockServiceIcon}>🧹</span>
					<span style={styles.mockServiceIcon}>🔧</span>
					<span style={styles.mockServiceIcon}>❄️</span>
					<span style={styles.mockServiceIcon}>⚡</span>
				  </div>
				</div>
			  </div>
			</div>

			<div style={styles.appContent}>
			  <h2 style={styles.appTitle}>Get the App for a Faster Experience</h2>
			  <p style={styles.appText}>
				Book, track and manage your services on the go. Available on iOS
				and Android.
			  </p>

			  <div style={styles.storeButtons}>
				<button style={styles.storeBtn}>▶ Google Play</button>
			  </div>
			</div>

			<div style={styles.qrWrap}>
			  <div style={styles.qrBox}>
				<div style={styles.fakeQr} />
			  </div>
			  <p style={styles.scanText}>Scan to download the app</p>
			</div>
		  </div>
		</section>

		{/* Support CTA */}
		<section style={styles.section}>
		  <div style={styles.supportBox}>
			<div style={styles.supportLeft}>
			  <div style={styles.supportIcon}>
				<Headphones size={28} color="#4f46e5" />
			  </div>
			  <div>
				<h3 style={styles.supportTitle}>
				  Need Help Finding the Right Service?
				</h3>
				<p style={styles.supportText}>
				  Our support team is here to help you 24/7
				</p>
			  </div>
			</div>

			<button style={styles.supportBtn}>
			  <Link
					to="/contact-us"
					style={{
						...styles.supportBtn,
						textDecoration: "none",
					}}
					>
					Contact Support <ChevronRight size={16} />
					</Link>
			</button>
		  </div>
		</section>

	  </div>
	</main>
  );
};

const styles = {
  page: {
	background: "#fafafa",
	padding: "24px 0 60px",
	fontFamily:
	  "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
	color: "#111827",
  },
  container: {
	width: "100%",
	maxWidth: "1440px",
	margin: "0 auto",
	padding: "0 24px",
  },
  section: {
	marginBottom: "32px",
  },

  heroSection: {
	marginBottom: "28px",
  },
  heroGrid: {
	display: "grid",
	gridTemplateColumns: "1.15fr 0.8fr 0.42fr",
	gap: "24px",
	alignItems: "center",
  },
  heroLeft: {
	paddingRight: "10px",
  },
  offerBadge: {
	display: "inline-flex",
	alignItems: "center",
	gap: "8px",
	background: "#eef2ff",
	color: "#4f46e5",
	borderRadius: "999px",
	fontSize: "14px",
	fontWeight: 700,
	padding: "8px 14px",
	marginBottom: "18px",
  },
  heroTitle: {
	fontSize: "66px",
	lineHeight: 1.06,
	fontWeight: 800,
	letterSpacing: "-1.5px",
	margin: 0,
	color: "#0f172a",
	marginBottom: "18px",
  },
  heroAccent: {
	color: "#3FC9A3",
  },
  heroText: {
	margin: 0,
	maxWidth: "560px",
	color: "#6b7280",
	fontSize: "24px",
	lineHeight: 1.6,
	marginBottom: "28px",
  },
  searchBar: {
	background: "#fff",
	border: "1px solid #ececec",
	borderRadius: "16px",
	display: "grid",
	gridTemplateColumns: "1.4fr 0.9fr 140px",
	overflow: "hidden",
	height: "64px",
	maxWidth: "760px",
	boxShadow: "0 6px 24px rgba(15, 23, 42, 0.04)",
  },
  searchInputWrap: {
	display: "flex",
	alignItems: "center",
	gap: "12px",
	padding: "0 18px",
	borderRight: "1px solid #f1f1f1",
  },
  searchInput: {
	border: "none",
	outline: "none",
	width: "100%",
	fontSize: "16px",
	background: "transparent",
	color: "#111827",
  },
  locationBox: {
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	gap: "8px",
	fontSize: "15px",
	color: "#374151",
	borderRight: "1px solid #f1f1f1",
  },
  searchBtn: {
	background: "#152B5C",
	color: "#fff",
	fontWeight: 700,
	fontSize: "16px",
	border: "none",
	cursor: "pointer",
  },
  heroTrustRow: {
	display: "flex",
	alignItems: "center",
	gap: "22px",
	marginTop: "22px",
	flexWrap: "wrap",
  },
  heroTrustItem: {
	display: "flex",
	alignItems: "center",
	gap: "8px",
	fontSize: "13.5px",
	fontWeight: 600,
	color: "#374151",
  },
  heroCenter: {},
  heroImageCard: {
	position: "relative",
	borderRadius: "22px",
	overflow: "hidden",
	height: "540px",
	background: "#f3f4f6",
  },
  heroImage: {
	width: "100%",
	height: "100%",
	objectFit: "cover",
  },
  playBtn: {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: "74px",
	height: "74px",
	borderRadius: "50%",
	background: "rgba(17, 24, 39, 0.35)",
	backdropFilter: "blur(6px)",
	border: "2px solid rgba(255,255,255,0.8)",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
  },
  trustedBadge: {
	position: "absolute",
	bottom: "18px",
	left: "18px",
	right: "18px",
	background: "rgba(255,255,255,0.95)",
	borderRadius: "16px",
	padding: "14px 18px",
	display: "flex",
	alignItems: "center",
	gap: "16px",
  },
  heroRating: {
	display: "flex",
	alignItems: "center",
	gap: "6px",
	fontSize: "22px",
	fontWeight: 800,
	color: "#111827",
	minWidth: "82px",
  },
  trustedTitle: {
	fontSize: "16px",
	fontWeight: 700,
	color: "#111827",
	marginBottom: "4px",
  },
  trustedSub: {
	fontSize: "13px",
	color: "#6b7280",
  },
  heroRight: {
	display: "flex",
	flexDirection: "column",
	gap: "16px",
  },
  sideInfoCard: {
	minHeight: "160px",
	borderRadius: "20px",
	padding: "24px 20px",
	display: "flex",
	alignItems: "center",
	gap: "14px",
  },
  sideIconWrap: {
	width: "46px",
	height: "46px",
	borderRadius: "50%",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	flexShrink: 0,
  },
  sideCardBody: {
	flex: 1,
  },
  sideCardTitle: {
	margin: 0,
	marginBottom: "6px",
	fontSize: "18px",
	fontWeight: 700,
	color: "#111827",
  },
  sideCardText: {
	margin: 0,
	fontSize: "14px",
	color: "#6b7280",
	lineHeight: 1.6,
  },

  rowHead: {
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	gap: "16px",
	marginBottom: "18px",
  },
  viewAllBtn: {
	display: "inline-flex",
	alignItems: "center",
	gap: "8px",
	color: "#4f46e5",
	fontWeight: 700,
	fontSize: "14px",
	background: "transparent",
	border: "none",
  },
  sectionTitle: {
	fontSize: "22px",
	lineHeight: 1.2,
	fontWeight: 700,
	margin: 0,
	color: "#111827",
  },

  // Quick Services Access — left side (75%) is a 7-column grid of the
  // QAS_* cards (20 images, each a complete photo+title+arrow design),
  // given most of the width so the service list reads clearly; rows
  // aren't fixed — after every 7 images the grid auto-wraps to a new row
  // (3 rows: 7 + 7 + 6), each sized to that row's own content height.
  // Right side (25%) is the welcome banner photo. Both are flex children
  // with the default (stretch) cross-axis alignment, so the welcome photo
  // automatically matches the grid's rendered height with no hardcoded
  // height on either side.
  quickAccessSplit: {
	display: "flex",
	gap: "24px",
	alignItems: "stretch",
	flexWrap: "wrap",
  },
  quickAccessGrid: {
	flex: "3 1 0",
	minWidth: "360px",
	display: "grid",
	gridTemplateColumns: "repeat(7, 1fr)",
	gridAutoRows: "auto",
	gap: "12px",
  },
  // Card wrapper added around every QAS_* image so a service name always
  // shows underneath — some of the QAS_* PNGs have a title baked into the
  // artwork itself, others are a plain product photo with none, so this
  // caption row renders uniformly for every card instead of only the ones
  // whose art happens to include text.
  quickAccessCard: {
	display: "flex",
	flexDirection: "column",
	background: "#fff",
	border: "1px solid #ececec",
	borderRadius: "14px",
	overflow: "hidden",
  },
  quickAccessGridImg: {
	width: "100%",
	height: "auto",
	objectFit: "contain",
	display: "block",
  },
  quickAccessCaption: {
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	gap: "6px",
	padding: "8px 10px",
	fontSize: "12.5px",
	fontWeight: 700,
	color: "#111827",
	lineHeight: 1.3,
	borderTop: "1px solid #f1f1f1",
  },
  quickAccessWelcomeWrap: {
	flex: "1 1 0",
	minWidth: "220px",
	display: "block",
	borderRadius: "22px",
	overflow: "hidden",
  },
  quickAccessWelcomeImg: {
	width: "100%",
	height: "100%",
	minHeight: "320px",
	objectFit: "cover",
	display: "block",
  },

  trustStrip: {
	background: "#fff",
	border: "1px solid #ececec",
	borderRadius: "20px",
	padding: "24px 28px",
	display: "grid",
	gridTemplateColumns: "repeat(4, 1fr)",
	gap: "20px",
  },
  trustItem: {
	display: "flex",
	alignItems: "center",
	gap: "14px",
  },
  trustIconBox: {
	width: "52px",
	height: "52px",
	borderRadius: "50%",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	flexShrink: 0,
  },
  trustTitle: {
	margin: 0,
	marginBottom: "6px",
	fontSize: "16px",
	fontWeight: 700,
	color: "#111827",
  },
  trustDesc: {
	margin: 0,
	fontSize: "14px",
	lineHeight: 1.6,
	color: "#6b7280",
  },

  categoryGridWrap: {
	display: "grid",
	gridTemplateColumns: "290px 1fr",
	gap: "24px",
	alignItems: "stretch",
  },
  leftIntro: {
	paddingTop: "8px",
  },
  badge: {
	display: "inline-flex",
	alignItems: "center",
	gap: "8px",
	background: "#eef2ff",
	color: "#4f46e5",
	borderRadius: "999px",
	fontSize: "12px",
	fontWeight: 600,
	padding: "6px 12px",
	marginBottom: "18px",
  },
  sectionTitleLarge: {
	fontSize: "34px",
	lineHeight: 1.1,
	fontWeight: 800,
	margin: 0,
	marginBottom: "14px",
	letterSpacing: "-0.6px",
  },
  sectionSubtext: {
	margin: 0,
	color: "#6b7280",
	fontSize: "15px",
	lineHeight: 1.7,
	maxWidth: "240px",
  },

  // ── Membership / Subscription plans ────────────────────────────────────────
  membershipWrap: {
	display: "grid",
	gridTemplateColumns: "300px 1fr",
	gap: "36px",
	alignItems: "start",
	background: "#faf9ff",
	border: "1px solid #eee9ff",
	borderRadius: "28px",
	padding: "36px",
  },
  membershipIntro: {
	display: "flex",
	flexDirection: "column",
	gap: "16px",
  },
  membershipEyebrowLink: {
	display: "inline-flex",
	alignItems: "center",
	gap: "6px",
	color: "#4f46e5",
	fontWeight: 700,
	fontSize: "12px",
	textDecoration: "none",
	background: "#fff",
	border: "1px solid #e0d9ff",
	borderRadius: "999px",
	padding: "6px 12px",
	width: "fit-content",
  },
  membershipTitle: {
	margin: 0,
	fontSize: "32px",
	fontWeight: 800,
	lineHeight: 1.18,
	color: "#111827",
	letterSpacing: "-0.5px",
  },
  membershipTitleAccent: {
	color: "#4f46e5",
  },
  membershipIntroText: {
	margin: 0,
	color: "#6b7280",
	fontSize: "14px",
	lineHeight: 1.7,
  },
  membershipFeatureRow: {
	display: "flex",
	flexDirection: "column",
	gap: "14px",
	marginTop: "8px",
  },
  membershipFeatureItem: {
	display: "flex",
	alignItems: "center",
	gap: "10px",
	fontSize: "13px",
	fontWeight: 700,
	color: "#374151",
  },
  membershipFeatureIcon: {
	width: "34px",
	height: "34px",
	borderRadius: "10px",
	background: "#eef2ff",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	flexShrink: 0,
  },

  membershipRight: {
	display: "flex",
	flexDirection: "column",
	gap: "18px",
	minWidth: 0,
  },
  membershipGrid: {
	display: "grid",
	gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
	gap: "16px",
	alignItems: "stretch",
  },
  membershipCard: {
	position: "relative",
	background: "#fff",
	border: "1px solid #ececec",
	borderRadius: "20px",
	padding: "22px 18px",
	display: "flex",
	flexDirection: "column",
	boxShadow: "0 6px 20px rgba(15,23,42,0.05)",
  },
  membershipCardPopular: {
	border: "2px solid #4f46e5",
	boxShadow: "0 16px 34px rgba(79,70,229,0.18)",
  },
  popularRibbon: {
	position: "absolute",
	top: "-13px",
	left: "50%",
	transform: "translateX(-50%)",
	display: "inline-flex",
	alignItems: "center",
	gap: "5px",
	background: "#4f46e5",
	color: "#fff",
	fontSize: "11px",
	fontWeight: 800,
	padding: "6px 14px",
	borderRadius: "999px",
	boxShadow: "0 6px 16px rgba(79,70,229,0.35)",
	whiteSpace: "nowrap",
  },
  planHeadRow: {
	display: "flex",
	alignItems: "flex-start",
	gap: "10px",
	marginBottom: "16px",
  },
  planIconWrap: {
	width: "38px",
	height: "38px",
	borderRadius: "12px",
	background: "#eef2ff",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	flexShrink: 0,
  },
  planIconWrapPopular: {
	background: "#4f46e5",
  },
  planName: {
	margin: 0,
	fontSize: "15px",
	fontWeight: 800,
	color: "#111827",
  },
  planTagline: {
	margin: "3px 0 0",
	fontSize: "11px",
	color: "#9ca3af",
	fontWeight: 600,
  },
  planPriceRow: {
	display: "flex",
	alignItems: "baseline",
	gap: "5px",
	marginBottom: "16px",
  },
  planPrice: {
	fontSize: "26px",
	fontWeight: 800,
	color: "#111827",
	letterSpacing: "-0.5px",
  },
  planPeriod: {
	fontSize: "12px",
	color: "#9ca3af",
	fontWeight: 600,
  },
  planDivider: {
	height: "1px",
	background: "#eee",
	border: "none",
	marginBottom: "16px",
  },
  featureList: {
	listStyle: "none",
	margin: 0,
	padding: 0,
	display: "flex",
	flexDirection: "column",
	gap: "10px",
	flex: 1,
	marginBottom: "20px",
  },
  featureItem: {
	display: "flex",
	alignItems: "flex-start",
	gap: "8px",
  },
  featureText: {
	fontSize: "12px",
	color: "#374151",
	lineHeight: 1.5,
  },
  planCta: {
	border: "1px solid #4f46e5",
	borderRadius: "12px",
	padding: "12px 0",
	fontSize: "13px",
	fontWeight: 800,
	cursor: "pointer",
	background: "#fff",
	color: "#4f46e5",
	width: "100%",
  },
  planCtaPopular: {
	background: "#4f46e5",
	color: "#fff",
	border: "1px solid #4f46e5",
	boxShadow: "0 10px 22px rgba(79,70,229,0.28)",
  },

  viewAllCard: {
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "center",
	textAlign: "center",
	gap: "8px",
	background: "#fafafe",
	border: "2px dashed #d6d0ff",
	borderRadius: "20px",
	padding: "22px 16px",
	textDecoration: "none",
	cursor: "pointer",
  },
  viewAllIconWrap: {
	width: "44px",
	height: "44px",
	borderRadius: "50%",
	background: "#eef2ff",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
  },
  viewAllTitle: {
	fontSize: "15px",
	fontWeight: 800,
	color: "#111827",
  },
  viewAllText: {
	margin: 0,
	fontSize: "11px",
	color: "#6b7280",
	lineHeight: 1.5,
  },
  viewAllLink: {
	display: "inline-flex",
	alignItems: "center",
	gap: "6px",
	color: "#4f46e5",
	fontWeight: 700,
	fontSize: "12px",
	marginTop: "4px",
  },


  categoryGrid: {
	display: "grid",
	gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
	gap: "16px",
  },
  categoryCard: {
	borderRadius: "16px",
	overflow: "hidden",
	display: "flex",
	flexDirection: "column",
	boxShadow: "0 0 0 1px rgba(17,24,39,0.04)",
  },
  categoryImage: {
	width: "100%",
	aspectRatio: "1 / 1",
	objectFit: "cover",
	display: "block",
  },
  categoryCardBody: {
	padding: "18px",
	display: "flex",
	flexDirection: "column",
	flex: 1,
  },
  cardTitle: {
	fontSize: "18px",
	lineHeight: 1.3,
	fontWeight: 700,
	margin: 0,
	marginBottom: "8px",
	color: "#111827",
  },
  cardDesc: {
	fontSize: "13px",
	lineHeight: 1.6,
	color: "#6b7280",
	margin: 0,
	marginBottom: "18px",
  },
  linkBtn: {
	marginTop: "auto",
	display: "inline-flex",
	alignItems: "center",
	gap: "8px",
	color: "#4f46e5",
	fontSize: "14px",
	fontWeight: 700,
	padding: 0,
	background: "transparent",
	border: "none",
  },

  borderedSection: {
	borderTop: "1px solid #ececec",
	borderBottom: "1px solid #ececec",
	paddingTop: "36px",
	paddingBottom: "36px",
  },
  sectionSubtextSmall: {
	margin: 0,
	color: "#6b7280",
	fontSize: "14px",
	lineHeight: 1.6,
  },

  // How It Works now lives entirely in the .cn-how-* className/embedded-
  // <style> block next to its JSX (needed real CSS for :hover, absolute
  // connector positioning, and media queries) — no styles.* objects here.

  proGrid: {
	display: "grid",
	gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
	gap: "16px",
  },
  proCard: {
	background: "#fff",
	borderRadius: "14px",
	border: "1px solid #ececec",
	overflow: "hidden",
  },
  imageWrap: {
	position: "relative",
	height: "220px",
	overflow: "hidden",
	background: "#f3f4f6",
  },
  proImage: {
	width: "100%",
	height: "100%",
	objectFit: "cover",
	display: "block",
  },
  availableTag: {
	position: "absolute",
	left: "10px",
	top: "10px",
	background: "#dcfce7",
	color: "#16a34a",
	fontSize: "11px",
	fontWeight: 700,
	padding: "5px 9px",
	borderRadius: "999px",
  },
  proBody: {
	padding: "14px",
  },
  proName: {
	margin: 0,
	marginBottom: "4px",
	fontSize: "17px",
	fontWeight: 700,
	color: "#111827",
  },
  proRole: {
	margin: 0,
	marginBottom: "10px",
	fontSize: "13px",
	color: "#6b7280",
  },
  ratingRow: {
	display: "flex",
	alignItems: "center",
	gap: "6px",
	marginBottom: "10px",
  },
  ratingText: {
	fontSize: "13px",
	color: "#374151",
	fontWeight: 600,
  },
  jobsText: {
	margin: 0,
	fontSize: "13px",
	color: "#6b7280",
  },

  testimonialGrid: {
	display: "grid",
	gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
	gap: "16px",
  },
  testimonialCard: {
	background: "#fff",
	border: "1px solid #ececec",
	borderRadius: "14px",
	padding: "22px",
  },
  quoteMark: {
	color: "#4f46e5",
	fontSize: "26px",
	lineHeight: 1,
	marginBottom: "8px",
  },
  stars: {
	display: "flex",
	gap: "2px",
	marginBottom: "14px",
  },
  testimonialText: {
	margin: 0,
	fontSize: "14px",
	lineHeight: 1.75,
	color: "#374151",
	minHeight: "78px",
  },
  userRow: {
	display: "flex",
	alignItems: "center",
	gap: "10px",
	marginTop: "18px",
  },
  userAvatar: {
	width: "38px",
	height: "38px",
	borderRadius: "50%",
	objectFit: "cover",
  },
  userName: {
	fontSize: "14px",
	fontWeight: 700,
	color: "#111827",
  },
  userCity: {
	fontSize: "12px",
	color: "#6b7280",
  },

  appBanner: {
	background: "linear-gradient(90deg, #eef0ff 0%, #f3f1ff 100%)",
	borderRadius: "20px",
	padding: "28px 28px",
	display: "grid",
	gridTemplateColumns: "240px 1fr 180px",
	alignItems: "center",
	gap: "28px",
	minHeight: "290px",
  },
  mobileMockWrap: {
	display: "flex",
	justifyContent: "center",
  },
  mobileMock: {
	width: "170px",
	height: "330px",
	borderRadius: "28px",
	background: "#111827",
	padding: "8px",
	boxShadow: "0 16px 40px rgba(17,24,39,0.22)",
  },
  mobileNotch: {
	width: "82px",
	height: "18px",
	background: "#111827",
	borderRadius: "0 0 14px 14px",
	margin: "0 auto",
	position: "relative",
	top: "-2px",
	zIndex: 2,
  },
  mobileScreen: {
	background: "#fff",
	borderRadius: "22px",
	height: "100%",
	marginTop: "-10px",
	padding: "18px 14px",
  },
  mockHello: {
	fontSize: "11px",
	color: "#6b7280",
	margin: "0 0 8px",
  },
  mockTitle: {
	fontSize: "18px",
	lineHeight: 1.25,
	margin: "0 0 12px",
	color: "#111827",
  },
  searchBoxMini: {
	background: "#f3f4f6",
	borderRadius: "12px",
	padding: "10px 12px",
	fontSize: "11px",
	color: "#9ca3af",
	marginBottom: "14px",
  },
  mockSmallTitle: {
	fontSize: "11px",
	color: "#111827",
	fontWeight: 700,
	marginBottom: "10px",
  },
  mockServiceRow: {
	display: "grid",
	gridTemplateColumns: "repeat(4, 1fr)",
	gap: "8px",
  },
  mockServiceIcon: {
	background: "#eef2ff",
	borderRadius: "12px",
	height: "42px",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	fontSize: "18px",
  },
  appContent: {},
  appTitle: {
	fontSize: "42px",
	lineHeight: 1.1,
	fontWeight: 800,
	margin: 0,
	marginBottom: "14px",
	letterSpacing: "-0.6px",
	maxWidth: "430px",
  },
  appText: {
	margin: 0,
	marginBottom: "24px",
	color: "#6b7280",
	fontSize: "16px",
	lineHeight: 1.7,
	maxWidth: "460px",
  },
  storeButtons: {
	display: "flex",
	gap: "14px",
	flexWrap: "wrap",
  },
  storeBtn: {
	background: "#111",
	color: "#fff",
	borderRadius: "12px",
	padding: "12px 18px",
	fontWeight: 700,
	fontSize: "15px",
	border: "none",
  },
  qrWrap: {
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	gap: "12px",
  },
  qrBox: {
	width: "118px",
	height: "118px",
	borderRadius: "10px",
	background: "#fff",
	padding: "10px",
	boxShadow: "0 0 0 1px rgba(17,24,39,0.06)",
  },
  fakeQr: {
	width: "100%",
	height: "100%",
	borderRadius: "4px",
	background:
	  "linear-gradient(90deg, #111 10%, transparent 10%, transparent 20%, #111 20%, #111 30%, transparent 30%, transparent 40%, #111 40%, #111 50%, transparent 50%, transparent 60%, #111 60%, #111 70%, transparent 70%, transparent 80%, #111 80%), linear-gradient(#111 10%, transparent 10%, transparent 20%, #111 20%, #111 30%, transparent 30%, transparent 40%, #111 40%, #111 50%, transparent 50%, transparent 60%, #111 60%, #111 70%, transparent 70%, transparent 80%, #111 80%)",
	backgroundSize: "22px 22px",
	backgroundColor: "#fff",
  },
  scanText: {
	margin: 0,
	textAlign: "center",
	color: "#4b5563",
	fontSize: "14px",
	lineHeight: 1.6,
	maxWidth: "120px",
  },

  supportBox: {
	background: "#f5f6fb",
	borderRadius: "18px",
	padding: "26px 28px",
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	gap: "20px",
  },
  supportLeft: {
	display: "flex",
	alignItems: "center",
	gap: "18px",
  },
  supportIcon: {
	width: "64px",
	height: "64px",
	borderRadius: "50%",
	background: "#e8e9ff",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	flexShrink: 0,
  },
  supportTitle: {
	margin: 0,
	marginBottom: "6px",
	fontSize: "30px",
	lineHeight: 1.15,
	fontWeight: 800,
	color: "#111827",
  },
  supportText: {
	margin: 0,
	color: "#6b7280",
	fontSize: "16px",
  },
  supportBtn: {
	background: "#4f46e5",
	color: "#fff",
	padding: "14px 22px",
	borderRadius: "12px",
	fontWeight: 700,
	fontSize: "15px",
	display: "inline-flex",
	alignItems: "center",
	gap: "8px",
	whiteSpace: "nowrap",
	border: "none",
  },

  // ── Booking Options — Instant / Schedule / Subscription ──────────────────
  bookingOptionsGrid: {
	display: "grid",
	gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
	gap: "20px",
  },
  bookingCard: {
	borderRadius: "20px",
	padding: "26px 24px",
	display: "flex",
	flexDirection: "column",
  },
  bookingBadge: {
	display: "inline-flex",
	alignItems: "center",
	gap: "6px",
	alignSelf: "flex-start",
	fontSize: "11px",
	fontWeight: 800,
	padding: "6px 12px",
	borderRadius: "999px",
	marginBottom: "14px",
  },
  bookingTitle: {
	margin: 0,
	fontSize: "20px",
	fontWeight: 800,
	lineHeight: 1.3,
	color: "#111827",
  },
  bookingDesc: {
	margin: "10px 0 18px",
	fontSize: "13px",
	color: "#6b7280",
	lineHeight: 1.6,
  },
  bookingMiniGrid: {
	display: "grid",
	gridTemplateColumns: "repeat(2, 1fr)",
	gap: "10px",
	marginBottom: "16px",
  },
  bookingMiniTile: {
	background: "#fff",
	borderRadius: "12px",
	padding: "10px 12px",
  },
  bookingMiniName: {
	fontSize: "12px",
	fontWeight: 700,
	color: "#374151",
  },
  bookingMiniPrice: {
	fontSize: "14px",
	fontWeight: 800,
	color: "#4f46e5",
	marginTop: "2px",
  },
  bookingViewAll: {
	fontSize: "13px",
	fontWeight: 700,
	color: "#4f46e5",
	display: "inline-flex",
	alignItems: "center",
	gap: "6px",
	textDecoration: "none",
	marginBottom: "16px",
  },
  bookingDurationRow: {
	display: "grid",
	gridTemplateColumns: "1fr 1fr",
	gap: "10px",
  },
  bookingDurationTile: {
	background: "#fff",
	borderRadius: "14px",
	padding: "16px 14px",
  },
  bookingDurationTitle: {
	fontSize: "13px",
	fontWeight: 800,
	color: "#111827",
	marginTop: "8px",
  },
  bookingDurationSub: {
	fontSize: "11px",
	color: "#9ca3af",
	marginTop: "2px",
  },
  bookingDurationCount: {
	fontSize: "11px",
	fontWeight: 700,
	color: "#16a34a",
	marginTop: "8px",
  },
  bookingFeatureList: {
	listStyle: "none",
	margin: 0,
	padding: 0,
	display: "flex",
	flexDirection: "column",
	gap: "10px",
  },
  bookingFeatureItem: {
	display: "flex",
	alignItems: "center",
	gap: "8px",
	fontSize: "13px",
	fontWeight: 600,
	color: "#374151",
  },
  bookingCta: {
	marginTop: "auto",
	padding: "13px 0",
	borderRadius: "12px",
	color: "#fff",
	fontSize: "14px",
	fontWeight: 800,
	textAlign: "center",
	textDecoration: "none",
	display: "block",
  },
};

export default HomePageContent;
